import "../App.css";
import React from "react";
import { Row, Col, Container, Button } from "react-bootstrap";
import { FaLaptopCode } from "react-icons/fa";
// import {FaEnvelope, FaHeart} from "react-icons/fa";

export default function Skills(props) {
  return (
    <section>
      <div variant="dark" className="p-5 mx-5">
        <>
          <Row className="justify-content-center">
            <Col
              className="col-3 justify-content-center d-flex"
              xs={12}
              md={6}
              xl={6}
            >
              <h1 className="h1 banner_text2">
                <FaLaptopCode className="ps-1 mx-2" size={35} />
                Skills
              </h1>
            </Col>
          </Row>
          {/* className='mt-5 pt-5 mb-5 pb-5' */}
          {/* "https://www.flaticon.com/free-icons/javascript"   ,   "https://www.flaticon.com/free-icons/code"   ,  <a href="https://www.flaticon.com/free-icons/python-file" title="python file icons">Python file icons created by Flat Icons - Flaticon</a>,   <a href="https://www.flaticon.com/free-icons/java" title="java icons">Java icons created by Freepik - Flaticon</a>  ,   <a href="https://www.flaticon.com/free-icons/javascript" title="javascript icons">Javascript icons created by Freepik - Flaticon</a>  , <a href="https://www.flaticon.com/free-icons/machine-learning" title="machine learning icons">Machine learning icons created by netscript - Flaticon</a> ,<a href="https://www.flaticon.com/free-icons/letter-c" title="letter c icons">Letter c icons created by Hight Quality Icons - Flaticon</a> , <a href="https://www.flaticon.com/free-icons/coding" title="coding icons">Coding icons created by Freepik - Flaticon</a>  ,  <a href="https://www.flaticon.com/free-icons/html-5" title="html 5 icons">Html 5 icons created by Freepik - Flaticon</a> , <a href="https://www.flaticon.com/free-icons/css" title="css icons">Css icons created by Pixel perfect - Flaticon</a>  ,   <a href="https://www.flaticon.com/free-icons/react" title="react icons">React icons created by Kiranshastry - Flaticon</a>*/}
          <Container className="rounded p-xl-5">
            <Row className="text-center justify-content-center py-3 rounded">
              <Col className="col-xl-2 col-md-2 mx-md-2 mx-xs-2 col-xs-12 col-col mx-xl-3 my-3 mx-2  rounded">
                <img
                  alt="logo"
                  src="23.png"
                  // width="500"
                  height="80"
                  className="rounded mt-2  "
                />
                <h4 className="  h4 banner_text mt-2 mb-3 font-link">
                  Typescript
                </h4>
              </Col>
              <Col className="col-xl-2 col-md-2 mx-md-2 mx-xs-2 col-xs-12 col-col mx-xl-3 my-3 mx-2  rounded">
                <img
                  alt="logo"
                  src="9.png"
                  // width="500"
                  height="80"
                  className="rounded mt-2  "
                />
                <h4 className="  h4 banner_text mt-2 mb-3 font-link">
                  Javascript
                </h4>
              </Col>
              <Col className="col-xl-2 col-md-2 mx-md-2 mx-xs-2 col-xs-12 col-col mx-xl-3 my-3 mx-2  rounded">
                <img
                  alt="logo"
                  src="Go.png"
                  // width="500"
                  height="80"
                  className="rounded mt-2  "
                />
                <h4 className="  h4 banner_text mt-2 mb-3 font-link">Golang</h4>
              </Col>
              <Col className="col-xl-2 col-md-2 mx-md-2 mx-xs-2 col-xs-12 col-col mx-xl-3 my-3 mx-2  rounded">
                <img
                  alt="logo"
                  src="solana.png"
                  // width="500"
                  height="80"
                  className="rounded mt-2  "
                />
                <h4 className="  h4 banner_text mt-2 mb-3 font-link">
                  Solana/web3.js
                </h4>
              </Col>
              <Col className="col-xl-2 col-md-2 mx-md-2 mx-xs-2 col-xs-12 col-col mx-xl-3 my-3 mx-2  rounded">
                <img
                  alt="logo"
                  src="sol.png"
                  // width="500"
                  height="80"
                  className="rounded mt-2  "
                />
                <h4 className="  h4 banner_text mt-2 mb-3 font-link">
                  Solidity
                </h4>
              </Col>
            </Row>
            <Row className="text-center justify-content-center py-3 rounded">
              <Col className="col-xl-2 col-md-2 mx-md-2 mx-xs-2 col-xs-12 col-col mx-xl-3 my-3 mx-2  rounded">
                <img
                  alt="logo"
                  src="10.png"
                  // width="500"
                  height="80"
                  className="rounded mt-2  "
                />
                <h4 className="  h4 banner_text mt-2 mb-3 font-link">React</h4>
              </Col>
              <Col className="col-xl-2 col-md-2 mx-md-2 mx-xs-2 col-xs-12 col-col mx-xl-3 my-3 mx-2  rounded">
                <img
                  alt="logo"
                  src="24.png"
                  // width="500"
                  height="80"
                  className="rounded mt-2  "
                />
                <h4 className="  h4 banner_text mt-2 mb-3 font-link">
                  Next JS
                </h4>
              </Col>

              <Col className="col-xl-2 col-md-2 mx-md-2 mx-xs-2 col-xs-12 col-col mx-xl-3 my-3 mx-2  rounded">
                <img
                  alt="logo"
                  src="26.svg"
                  // width="500"
                  height="80"
                  className="rounded mt-2  "
                />
                <h4 className="  h4 banner_text mt-2 mb-3 font-link">
                  Turborepo
                </h4>
              </Col>
              <Col className="col-xl-2 col-md-2 mx-md-2 mx-xs-2 col-xs-12 col-col mx-xl-3 my-3 mx-2 rounded">
                <img
                  alt="logo"
                  src="11.png"
                  // width="500"
                  height="80"
                  className="rounded mt-2  "
                />
                <h4 className="  h4 banner_text mt-2 mb-3 font-link">
                  Bootstrap
                </h4>
              </Col>
              <Col className="col-xl-2 col-md-2 mx-md-2 mx-xs-2 col-xs-12 col-col mx-xl-3 my-3 mx-2  rounded">
                <img
                  alt="logo"
                  src="6.png"
                  // width="500"
                  height="80"
                  className="rounded mt-2  "
                />
                <h4 className="  h4 banner_text mt-2 mb-3 font-link">Bash</h4>
              </Col>
            </Row>
            <Row className="text-center justify-content-center py-3 rounded">
              <Col className="col-xl-2 col-md-2 mx-md-2 mx-xs-2 col-xs-12 col-col mx-xl-3 my-3 mx-2  rounded">
                <img
                  alt="logo"
                  src="13.png"
                  // width="500"
                  height="80"
                  className="rounded mt-2  "
                />
                <h4 className="  h4 banner_text mt-2 mb-3 font-link">AWS</h4>
              </Col>
              <Col className="col-xl-2 col-md-2 mx-md-2 mx-xs-2 col-xs-12 col-col mx-xl-3 my-3 mx-2  rounded">
                <img
                  alt="logo"
                  src="18.png"
                  // width="500"
                  height="80"
                  className="rounded mt-2  "
                />
                <h4 className="  h4 banner_text mt-2 mb-3 font-link">Docker</h4>
              </Col>
              <Col className="col-xl-2 col-md-2 mx-md-2 mx-xs-2 col-xs-12 col-col mx-xl-3 my-3 mx-2  rounded">
                <img
                  alt="logo"
                  src="14.png"
                  // width="500"
                  height="80"
                  className="rounded mt-2  "
                />
                <h4 className="  h4 banner_text mt-2 mb-3 font-link">Linux</h4>
              </Col>
              <Col className="col-xl-2 col-md-2 mx-md-2 mx-xs-2 col-xs-12 col-col mx-xl-3 my-3 mx-2  rounded">
                <img
                  alt="logo"
                  src="19.png"
                  // width="500"
                  height="80"
                  className="rounded mt-2  "
                />
                <h4 className="  h4 banner_text mt-2 mb-3 font-link">
                  Mongo DB
                </h4>
              </Col>
              <Col className="col-xl-2 col-md-2 mx-md-2 mx-xs-2 col-xs-12 col-col mx-xl-3 my-3 mx-2  rounded">
                <img
                  alt="logo"
                  src="25.png"
                  // width="500"
                  height="80"
                  className="rounded mt-2  "
                />
                <h4 className="  h4 banner_text mt-2 mb-3 font-link">
                  PostgreSQL
                </h4>
              </Col>
            </Row>
            <Row className="text-center justify-content-center py-3 rounded">
              <Col className="col-xl-2 col-md-2 mx-md-2 mx-xs-2 col-xs-12 col-col mx-xl-3 my-3 mx-2  rounded">
                <img
                  alt="logo"
                  src="2.png"
                  // width="500"
                  height="80"
                  className="rounded mt-2  "
                />
                <h4 className="  h4 banner_text mt-2 mb-3 font-link">JAVA</h4>
              </Col>
              <Col className="col-xl-2 col-md-2 mx-md-2 mx-xs-2 col-xs-12 col-col mx-xl-3 my-3 mx-2  rounded">
                <img
                  alt="logo"
                  src="4.png"
                  // width="500"
                  height="80"
                  className="rounded mt-2  "
                />
                <h4 className="  h4 banner_text mt-2 mb-3 font-link">C++</h4>
              </Col>
              <Col className="col-xl-2 col-md-2 mx-md-2 mx-xs-2 col-xs-12 col-col mx-xl-3 my-3 mx-2  rounded">
                <img
                  alt="logo"
                  src="5.png"
                  // width="500"
                  height="80"
                  className="rounded mt-2  "
                />
                <h4 className="  h4 banner_text mt-2 mb-3 font-link">Python</h4>
              </Col>

              <Col className="col-xl-2 col-md-2 mx-md-2 mx-xs-2 col-xs-12 col-col mx-xl-3 my-3 mx-2  rounded">
                <img
                  alt="logo"
                  src="20.png"
                  // width="500"
                  height="80"
                  className="rounded mt-2  "
                />
                <h4 className="  h4 banner_text mt-2 mb-3 font-link">
                  Py Torch
                </h4>
              </Col>
              <Col className="col-xl-2 col-md-2 mx-md-2 mx-xs-2 col-xs-12 col-col mx-xl-3 my-3 mx-2  rounded">
                <img
                  alt="logo"
                  src="21.png"
                  // width="500"
                  height="80"
                  className="rounded mt-2  "
                />
                <h4 className="  h4 banner_text mt-2 mb-3 font-link">
                  Tensor Flow
                </h4>
              </Col>
            </Row>
          </Container>
        </>
      </div>
    </section>
  );
}
